import React from 'react';
import { Text } from '@wix/design-system';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
export const AnonymousFooter = _ref => {
  let {
    taxesNotIncluded
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal"
  }, taxesNotIncluded ? /*#__PURE__*/React.createElement(React.Fragment, null, t('domain_search_gate.storefront_results.disclaimer.tax_not_included'), /*#__PURE__*/React.createElement("br", null)) : null, t('domain_search_gate.storefront_results.disclaimer.final_price'));
};
//# sourceMappingURL=AnonymousFooter.js.map